export default "/kiban/_next/static/images/mail-c4de21a313f1c1e896279300e1f37b09.png";